<template>
  <div class="ota-app">
    <router-view :key="reloadKey" @changeLocale="changeLocale" />
  </div>
</template>

<script>
import changeLocaleMixin from 'mixins/changeLocaleMixin'
import triplaLocalStorage from 'utilities/triplaLocalStorage'

export default {
  name: 'OtaApp',
  mixins: [changeLocaleMixin],
  provide() {
    return { changeLocale: this.changeLocale }
  },
  created() {
    this.checkLocale()
  },
  mounted() {
    document.documentElement.style.setProperty('--theme-btn-color', '#C21E58')
    document.documentElement.style.setProperty('--theme-font-color', '#fff')
  },
  methods: {
    checkLocale() {
      // currently we do not consider the browser's language
      const currentLang = triplaLocalStorage.getItem('triplabot_locale')

      if (currentLang) return

      this.changeLocale('ja')
    }
  }
}
</script>
